import BannerNotification from '@atoms/BannerNotification/BannerNotification';
import BannerNotificationStylesEnum from '@models/enums/BannerNotificationStylesEnum';
import ErrorBannerNotificationEnum from '@models/enums/ErrorBannerNotificationEnum';
import useErrorNotificationStore from '@state/ErrorBannerNotificationDisplayStore';
import { AnimatePresence, motion } from 'framer-motion';

interface Props {
  readonly apiDownLabel: string;
  readonly closeLabel: string;
  readonly accountDeleteAddressLabel: string;
  readonly accountDefaultAddressUpdateLabel: string;
  readonly accountDeleteContactSubmitLabel: string;
  readonly accountGetOrderDetailsLabel: string;
  readonly shippingPickUpLocationsLabel: string;
  readonly lightboxOuterImagesLabel: string;
  readonly miniBasketDetailsLabel: string;
  readonly orderSummaryRemoveVoucherLabel: string;
  readonly productDetailsNotifyMeLabel: string;
  readonly cartRemoveItemLabel: string;
  readonly newsletterSignupBannerLabel: string;
  readonly newsletterSignupPopupLabel: string;
  readonly onlineRetailersDataLabel: string;
  readonly searchResultsLabel: string;
}

const ErrorBannerNotification = ({
  apiDownLabel,
  closeLabel,
  accountDeleteAddressLabel,
  accountDefaultAddressUpdateLabel,
  accountDeleteContactSubmitLabel,
  accountGetOrderDetailsLabel,
  shippingPickUpLocationsLabel,
  lightboxOuterImagesLabel,
  miniBasketDetailsLabel,
  orderSummaryRemoveVoucherLabel,
  productDetailsNotifyMeLabel,
  cartRemoveItemLabel,
  newsletterSignupBannerLabel,
  newsletterSignupPopupLabel,
  onlineRetailersDataLabel,
  searchResultsLabel,
}: Props) => {
  const { errorBannerNotification, setErrorBannerNotification } =
    useErrorNotificationStore();

  const ErrorBannerNotificationLookup = Object.fromEntries(
    Object.entries(ErrorBannerNotificationEnum).map(([key, value]) => [
      value,
      {
        AccountDeleteAddress: accountDeleteAddressLabel,
        AccountDefaultAddressUpdate: accountDefaultAddressUpdateLabel,
        AccountDeleteContactSubmit: accountDeleteContactSubmitLabel,
        AccountGetOrderDetails: accountGetOrderDetailsLabel,
        ShippingPickUpLocations: shippingPickUpLocationsLabel,
        LightboxOuterImages: lightboxOuterImagesLabel,
        MiniBasketDetails: miniBasketDetailsLabel,
        OrderSummaryRemoveVoucher: orderSummaryRemoveVoucherLabel,
        ProductDetailsNotifyMe: productDetailsNotifyMeLabel,
        CartRemoveItem: cartRemoveItemLabel,
        NewsletterSignupBanner: newsletterSignupBannerLabel,
        NewsletterSignupPopup: newsletterSignupPopupLabel,
        OnlineRetailersData: onlineRetailersDataLabel,
        SearchResults: searchResultsLabel,
      }[key as keyof typeof ErrorBannerNotificationEnum],
    ])
  ) as Record<ErrorBannerNotificationEnum, string>;

  const currentError = errorBannerNotification
    ? ErrorBannerNotificationLookup[errorBannerNotification]
    : '';

  return (
    <AnimatePresence>
      {errorBannerNotification && (
        <motion.div
          animate={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <BannerNotification
            displayStyle={BannerNotificationStylesEnum.Error}
            iconName="warning"
            caption={apiDownLabel}
            title={currentError}
            closeLabel={closeLabel}
            className="bg-white"
            onDismissNotification={() => setErrorBannerNotification(null)}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ErrorBannerNotification;
